/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const MenuLeft: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="menu-left" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1246.6666666666665 170H113.3333333333333V283.3333333333335H1246.6666666666665V170zM963.3333333333331 623.3333333333334H113.3333333333333V736.6666666666667H963.3333333333331V623.3333333333334zM1246.6666666666665 1076.6666666666667H113.3333333333333V1190H1246.6666666666665V1076.6666666666667z" : "M997.3333333333334 136H90.6666666666667V226.6666666666667H997.3333333333334V136zM770.6666666666667 498.6666666666666H90.6666666666667V589.3333333333333H770.6666666666667V498.6666666666666zM997.3333333333334 861.3333333333333H90.6666666666667V952H997.3333333333334V861.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
MenuLeft.displayName = `Blueprint5.Icon.MenuLeft`;
export default MenuLeft;
